module.exports = __webpack_public_path__ + "hero-next-17255d3496b6bdb161243d7e5461fe48.bundle.svg";